import React from "react";
import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import "./App.css";
import { AppRouter } from "routes/AppRouter";

import { datadogRum } from "@datadog/browser-rum";
import { splitLink } from "services/apollo.service";
function App() {
  datadogRum.init({
    applicationId: "3b76cf32-dea4-4d18-b623-a2b693456b32",
    clientToken: "pub5e989cd99b4f36779340ad4413ddf031",
    site: "us5.datadoghq.com",
    service: "explorator",
    env: process.env.REACT_APP_BRANCH,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,

    trackUserInteractions: true,
    defaultPrivacyLevel: "allow",
  });

  datadogRum.startSessionReplayRecording();
  const client = new ApolloClient({
    link: splitLink,
    // uri: APP_CONSTANTS.gql_connection,
    cache: new InMemoryCache(),
  });
  // eslint-disable-next-line react/react-in-jsx-scope
  return (
    <ApolloProvider client={client}>
      <AppRouter />
    </ApolloProvider>
  );
}

export default App;
